export default __webpack_public_path__ + "static/media/srisailamVisitSeven.5d5d0b33.jpg";